import { useLocation } from "react-router-dom";
import React, { useEffect } from "react";
import GeneralAuthentication from "../general/GeneralAuthentication";
import AuthBrokerProspect from "../general/AuthBrokerProspect";
import { useDispatch } from "react-redux";
import MainPane from "../general/MainPane";
import CheckForInvalidLink from "../general/CheckForInvalidLink";
import TwoPanesPanel from "../general/TwoPanesPanel";
import MainArea from "../ViewCompareComp/MainArea";
import {
  storeProspectidForCompareView,
  storeResponseIdForCompareView,
} from "../store/compareview";

const ViewCompare = () => {
  const { search } = useLocation();
  const dispatch = useDispatch();

  const queryParams = new URLSearchParams(window.location.search);

  const prospectid = queryParams.get("id");
  const responseid = queryParams.get("rid");

  let valid = false;
  if (prospectid && prospectid.length >= 24) valid = true;

  dispatch(storeProspectidForCompareView(prospectid));
  dispatch(storeResponseIdForCompareView(responseid));

  return (
    <GeneralAuthentication>
      <CheckForInvalidLink valid={valid}>
        <MainPane>
          <MainArea></MainArea>
        </MainPane>
      </CheckForInvalidLink>
    </GeneralAuthentication>
  );
};

export default ViewCompare;
